import getAuditTrailParahubExportRequest from '@domain/model/request/parahub/getAuditTrailParahubExportRequest';
import getAuditTrailParahubExport from '@hooks/parahub/getAuditTrailParahubExport';

const useGetAuditTrailParahubExport = (payload) => {
    const queries = getAuditTrailParahubExportRequest(payload);
    return getAuditTrailParahubExport({ queries });
};

export default useGetAuditTrailParahubExport;
